"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var barchartIcon = function barchartIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,22.5H23V.75c0-.41-.22-.75-.5-.75h-3c-.28,0-.5.34-.5.75V22.5H17V11.25c0-.41-.22-.75-.5-.75h-3c-.28,0-.5.34-.5.75V22.5H11V8.25c0-.41-.22-.75-.5-.75h-3c-.28,0-.5.34-.5.75V22.5H5V15.75c0-.41-.22-.75-.5-.75h-3c-.28,0-.5.34-.5.75V22.5H.5c-.28,0-.5.34-.5.75s.22.75.5.75h23c.28,0,.5-.34.5-.75S23.78,22.5,23.5,22.5Z",
    fill: "#004864"
  }));
};

var _default = barchartIcon;
exports["default"] = _default;